import { SortDirection } from "global";
import { useForm } from "../../../hooks/useForm";
import {
  NetworkUserRankSortKey,
  useGetNetworkRankingAsAdminQuery,
} from "../../../lib/apollo/graphql/generated";
import { FETCH_SIZE } from "../../../utilities/constants";
import { formatDate } from "../../../utilities/format";
import { getTotalPages } from "../../../utilities/pagination";
import PageWrapper from "../../common/components/PageWrapper";
import Table from "../../common/components/Table";

export default function NetworkRankingContainer() {
  const [filters, onChange, onBatch] = useForm({
    page: 1,
    limit: FETCH_SIZE,
    sortKey: NetworkUserRankSortKey.Count,
    sortDirection: "DESC" as SortDirection,
  });

  const { data, loading } = useGetNetworkRankingAsAdminQuery({
    variables: filters,
  });

  const networks = data?.getReferralNetworkUsersRankAsAdmin.edges || [];
  const totalPages = getTotalPages(
    data?.getReferralNetworkUsersRankAsAdmin.pageInfo.totalCount || 0
  );

  return (
    <PageWrapper>
      <Table.Wrapper>
        <Table.Header
          tabs={[
            { label: "순위", sortKey: NetworkUserRankSortKey.Count },
            { label: "이름" },
            { label: "닉네임" },
            { label: "구분" },
            { label: "추천인 수" },
            { label: "네트워크 맴버 수" },
            { label: "네트워크 리워드" },
            { label: "가입일자" },
            { label: "최근 활동" },
          ]}
          sort={{
            key: filters.sortKey,
            direction: filters.sortDirection,
            onSort: (sortKey, sortDirection) => {
              onBatch({
                ...filters,
                sortKey,
                sortDirection,
              });
            },
          }}
        />
        <Table.Body isLoading={loading} isEmpty={!networks?.length}>
          {networks?.map((network, index) => {
            const isCaregiver = !!network?.caregiver;
            const user = network?.caregiver || network?.guardian;

            return (
              <Table.Row>
                <Table.Column>{index + 1}위</Table.Column>
                <Table.Column>{user?.name}</Table.Column>
                <Table.Column>{user?.username}</Table.Column>
                <Table.Column>{isCaregiver ? "보호사" : "보호자"}</Table.Column>
                <Table.Column>
                  {(user?.invitedUserCount || 0).toLocaleString()}명
                </Table.Column>
                <Table.Column>
                  {(network?.totalNetworkUserCount || 0).toLocaleString()}명
                </Table.Column>
                <Table.Column>
                  {(network?.totalNetworkRewardPoint || 0).toLocaleString()}원
                </Table.Column>
                <Table.Column>
                  {formatDate(user?.createdAt, "YY.MM.DD")}
                </Table.Column>
                <Table.Column>
                  {formatDate(user?.lastSignInAt, "YY.MM.DD HH:mm")}
                </Table.Column>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Wrapper>
      <Table.Pagination
        total={totalPages}
        page={filters.page}
        onPageChange={(page) => onChange("page", page)}
      />
    </PageWrapper>
  );
}
